import React from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import { Button, FormControl, Grid } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import { FormField } from '@iris-platform/iris-react-ui';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Call from '@material-ui/icons/Call';
import { toString, concat } from 'ramda';
import Panel from '../Panel';
// import NtmTrace from './NtmTrace';
import CallAttempts from './CallAttempts';
import OutboundSummary from './OutboundSummary';
import InboundSummary from './InboundSummary';
import InboundPercentSummary from './InboundPercentSummary';
import InternationalSummary from './InternationalSummary';
import BlockedSummary from './BlockedSummary';
import HighRiskSummary from './HighRiskSummary';
import OnNetSummary from './OnNetSummary';
import DateFilter from './DateFilterCard';
import { GET_CALL_ATTEMPTS, GET_OUTBOUND_CALLS, GET_INBOUND_CALLS, GET_ONNET_CALLS, GET_HIGH_RISK_CALLS} from './queries';
// import DataProcessor from './dataprocessor';

// import React from 'react';
// import {curveCatmullRom} from 'd3-shape';
// import ShowcaseButton from '../showcase-components/showcase-button';
import 'react-vis/dist/style.css';

import './newStyles.css';
import LoadingOverlay from 'react-loading-overlay';

const styles = theme => ({
  root: {
    opacity: '1',
    backgroundColor: '#fff',
    marginTop: '0 !important',
    border: '1px solid #ccc',
    '&:focus-within': {
      border: '1px solid #66afe9',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
  panelHeader: {
    position: 'relative',
  },
  title: {
    display: 'block',
  },
  btn: {
    marginTop: '20px',
  },
  formControl: {
    margin: theme.spacing.unit,
    width: '100%',
    flexDirection: 'row',
    fontSize: '14px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
  },
  formFieldWrapper: {
    width: 350,
    display: 'inline-block',
    margin: '0 10px',
  },
  searchBtn: {
    width: 200,
    textAlign: 'center',
    marginLeft: '30px',
    marginTop: '-8px',
  },
  healthIndicesWrapper: {
    margin: '10px 5px',
    textAlign: 'right',
  },

  selectDropdown: {
    display: 'inline-block',
    width: 350,
    margin: '0 10px',
  },
  search: {
    padding: 0,
  },
  searchIcon: {
    top: '10px',
    right: '4px',
    color: '#ccc',
  },
  searchInput: {
    border: '1px solid #ccc',
  },
  iconStyles: {
    fill: '#1682bc',
  },
  chartLabelstyles:{
    fontSize: '12px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    fontWeight: 'bold',
  },
  noRecords: {
    textAlign: 'center',
    color: 'red',
    fontSize: '15px',
    padding: '10px',
    margin: '15px auto',
    border: '1px dotted red',
  },

});

class CallSummaryData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appDomain: '',
      callAttemptsData: [],
      outboundCallsData: [],
      inboundCallsData: [],
      onNetCallsData: [],
      inboundPercentCallsData: [],
      updatedHighRiskData: [],
      searchStart: false,
      searchDone: false,
      traceEntered: false,
      isRegex: false,
      shortTime: false
    };
  }

  compress = (pn) => {
    const regex = /[-(). ]/g;
    return pn.replace(regex, '');
  }

  onChangeInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  onSearchCalls = async () => {
    const { appDomain, isRegex } = this.state;
    const { searchValues } = this.props;
    const startTime = searchValues.startTime;
    const endTime = searchValues.endTime;
    console.log('[onSearchCalls] startTime: ', startTime);
    console.log('[onSearchCalls] endTime: ', endTime);
    console.log('[onSearchCalls] appDomain: ', appDomain);
    if(endTime - startTime === 86400000){
      this.setState({ shortTime: true });
    }else{
      this.setState({ shortTime: false });
      this.setState({searchStart: true});
      const inpAppDomain = appDomain;
      this.setState({ appDomain: inpAppDomain });
      const updatedAttemptsData = await this.fetchCallAttemptsData(startTime, endTime, inpAppDomain);
      this.setState({ callAttemptsData: updatedAttemptsData });
      const updatedOutboundCallsData = await this.fetchOutboundCallsData(startTime, endTime, inpAppDomain);
      this.setState({ outboundCallsData: updatedOutboundCallsData });
      const updatedInboundCallsData = await this.fetchInboundCallsData(startTime, endTime, inpAppDomain);
      this.setState({ inboundCallsData: updatedInboundCallsData });
      const updatedOnNetCallsData = await this.fetchOnNetCallsData(startTime, endTime, inpAppDomain);
      this.setState({ onNetCallsData: updatedOnNetCallsData});
      const updatedInboundPercentCallsData = await this.fetchInboundPercentCallsData(startTime, endTime, inpAppDomain);
      this.setState({ inboundPercentCallsData: updatedInboundPercentCallsData});
      const updatedHighRiskData = await this.fetchHighRiskCallsData(startTime, endTime, inpAppDomain);
      this.setState({ updatedHighRiskData: updatedHighRiskData });
      this.setState({ searchDone: true });
      this.setState({searchStart: false});
    }

  }

  fetchCallAttemptsData = async (startTime, endTime, appDomain) => {
    const { client } = this.props;
    let result = [];
    let transformedData = [];
    console.log("send call summary query to graphql")
    try {
      const callDetails = await client.query({
        query: GET_CALL_ATTEMPTS,
        fetchPolicy: 'network-only',
        variables: {
          startTime: toString(startTime),
          endTime: toString(endTime),
          appDomain: appDomain
        },
      });
      console.log("logging callDetails from index.jsx");
      console.log(callDetails);
      // let pagecallDetails = [];
      result = callDetails.data.getCallAttempts ;

      result.forEach(
          function(val,index){
              let domain = val.key; 
              let data = [];
              val.CallSummary.buckets.forEach(function(val, index){
                  //console.log(val);
                  let sumDate = val.key;
                  let sumVal = val.SumCallAttempts.value;
                  data.push({x:sumDate, y:sumVal, legend: 'Call Attempts'});
              })
              transformedData.push({domain: domain, data: data})
          }
      )
      console.log("transformed Call Attempts Data",transformedData);

    } catch (error) {
      // this.setState({ error });
      console.error(error);
    } finally {
      // this.setState({ saving: false });
    }
    return transformedData;
  }

  fetchOutboundCallsData = async (startTime, endTime, appDomain) => {
    const { client } = this.props;
    let result = [];
    let transformedData = [];
    console.log("send outbound call query to graphql")
    try {
      const callDetails = await client.query({
        query: GET_OUTBOUND_CALLS,
        fetchPolicy: 'network-only',
        variables: {
          startTime: toString(startTime),
          endTime: toString(endTime),
          appDomain: appDomain
        },
      });
      console.log("logging outbound call from index.jsx");
      console.log(callDetails);
      // let pagecallDetails = [];
      result = callDetails.data.getOutboundCalls ;

      result.forEach(
        function(val,index){
            let domain = val.key; 
            let attemptsData = [];
            let ansData = [];
            let unAnsData = [];
            let errorData = [];
            let internationalCalls = [];
            let blockedCalls = [];
            val.CallSummary.buckets.forEach(function(val, index){
                //console.log(val);
                let sumDate = val.key;
                let sumAttemptsVal = val.SumCallAttempts.value;
                let sumAnsVal = val.SumCallsAnsAudio.value + val.SumCallsAnsNoStats.value 
                        + val.SumCallsAnsNoAudio.value;
                let sumErrorVal = val.SumCallErrors.value + val.SumCallsFailed.value;
                let sumUnAnsVal = val.SumUnAnsCalls.value;
                let sumInternational = val.SumCallsInternational.value;
                let sumBlocked = val.SumCallsBlocked.value;
                attemptsData.push({x:sumDate, y:sumAttemptsVal, legend: "Call Attempts"});
                ansData.push({x:sumDate, y:sumAnsVal, legend: "Answered Calls"});
                unAnsData.push({x:sumDate, y:sumUnAnsVal, legend: "Unanswered Calls"});
                errorData.push({x:sumDate, y:sumErrorVal, legend: "Failed Calls"});
                internationalCalls.push({x:sumDate, y:sumInternational, legend: "International Calls"});
                blockedCalls.push({x:sumDate, y:sumBlocked, legend: "Blocked Calls"});
            })
            transformedData.push({domain: domain, attemptsData: attemptsData,
              ansData: ansData, unAnsData: unAnsData, errorData: errorData, 
              internationalCalls: internationalCalls, blockedCalls: blockedCalls});
        }
    )
      console.log("transformed Outbound Data",transformedData);

    } catch (error) {
      // this.setState({ error });
      console.error(error);
    } finally {
      // this.setState({ saving: false });
    }
    return transformedData;
  }

  fetchInboundCallsData = async (startTime, endTime, appDomain) => {
    const { client } = this.props;
    let result = [];
    let transformedData = [];
    console.log("send inbound call query to graphql")
    try {
      const callDetails = await client.query({
        query: GET_INBOUND_CALLS,
        fetchPolicy: 'network-only',
        variables: {
          startTime: toString(startTime),
          endTime: toString(endTime),
          appDomain: appDomain
        },
      });
      console.log("logging inbound call from index.jsx");
      console.log(callDetails);
      // let pagecallDetails = [];
      result = callDetails.data.getInboundCalls ;

      result.forEach(
        function(val,index){
            let domain = val.key; 
            let attemptsData = [];
            let ansData = [];
            let unAnsData = [];
            let errorData = [];
            val.CallSummary.buckets.forEach(function(val, index){
                //console.log(val);
                let sumDate = val.key;
                let sumAttemptsVal = val.SumCallAttempts.value;
                let sumAnsVal = val.SumCallsAnsAudio.value + val.SumCallsAnsNoStats.value 
                        + val.SumCallsAnsNoAudio.value;
                let sumErrorVal = val.SumCallErrors.value + val.SumCallsFailed.value;
                let sumUnAnsVal = val.SumUnAnsCalls.value;
                attemptsData.push({x:sumDate, y:sumAttemptsVal, legend: "Call Attempts"});
                ansData.push({x:sumDate, y:sumAnsVal, legend: "Answered Calls"});
                unAnsData.push({x:sumDate, y:sumUnAnsVal, legend: "Unanswered Calls"});
                errorData.push({x:sumDate, y:sumErrorVal, legend: "Failed Calls"});
            })
            transformedData.push({domain: domain, attemptsData: attemptsData,
              ansData: ansData, unAnsData: unAnsData, errorData: errorData});
        }
    )
      console.log("transformed Inbound Data",transformedData);

    } catch (error) {
      // this.setState({ error });
      console.error(error);
    } finally {
      // this.setState({ saving: false });
    }
    return transformedData;
  }

  fetchOnNetCallsData = async (startTime, endTime, appDomain) => {
    const { client } = this.props;
    let result = [];
    let transformedData = [];
    console.log("send onNet call query to graphql")
    try {
      const callDetails = await client.query({
        query: GET_ONNET_CALLS,
        fetchPolicy: 'network-only',
        variables: {
          startTime: toString(startTime),
          endTime: toString(endTime),
          appDomain: appDomain
        },
      });
      console.log("logging onNet call from index.jsx");
      console.log(callDetails);
      // let pagecallDetails = [];
      result = callDetails.data.getOnNetCalls ;

      result.forEach(
        function(val,index){
            let domain = val.key; 
            let attemptsData = [];
            let ansData = [];
            let unAnsData = [];
            let errorData = [];
            val.CallSummary.buckets.forEach(function(val, index){
                //console.log(val);
                let sumDate = val.key;
                let sumAttemptsVal = val.SumCallAttempts.value;
                let sumAnsVal = val.SumCallsAnsAudio.value + val.SumCallsAnsNoStats.value 
                        + val.SumCallsAnsNoAudio.value;
                let sumErrorVal = val.SumCallErrors.value + val.SumCallsFailed.value;
                let sumUnAnsVal = val.SumUnAnsCalls.value;
                attemptsData.push({x:sumDate, y:sumAttemptsVal, legend: "Call Attempts"});
                ansData.push({x:sumDate, y:sumAnsVal, legend: "Answered Calls"});
                unAnsData.push({x:sumDate, y:sumUnAnsVal, legend: "Unanswered Calls"});
                errorData.push({x:sumDate, y:sumErrorVal, legend: "Failed Calls"});
            })
            transformedData.push({domain: domain, attemptsData: attemptsData,
              ansData: ansData, unAnsData: unAnsData, errorData: errorData});
        }
    )
      console.log("transformed onNet Data",transformedData);

    } catch (error) {
      // this.setState({ error });
      console.error(error);
    } finally {
      // this.setState({ saving: false });
    }
    return transformedData;
  }

  fetchInboundPercentCallsData = async (startTime, endTime, appDomain) => {
    const { client } = this.props;
    let result = [];
    let transformedData = [];
    console.log("send inbound call query to graphql")
    try {
      const callDetails = await client.query({
        query: GET_INBOUND_CALLS,
        fetchPolicy: 'network-only',
        variables: {
          startTime: toString(startTime),
          endTime: toString(endTime),
          appDomain: appDomain
        },
      });
      console.log("logging inbound call from index.jsx");
      console.log(callDetails);
      // let pagecallDetails = [];
      result = callDetails.data.getInboundCalls ;

      result.forEach(
        function(val,index){
            let domain = val.key; 
            // let attemptsData = [];
            // let ansData = [];
            // let unAnsData = [];
            // let errorData = [];
            let failureData = [];
            let answeredData = [];
            val.CallSummary.buckets.forEach(function(val, index){
                //console.log(val);
                let sumDate = val.key;
                let sumAttemptsVal = val.SumCallAttempts.value;
                let sumAnsVal = val.SumCallsAnsAudio.value + val.SumCallsAnsNoStats.value 
                        + val.SumCallsAnsNoAudio.value;
                let sumErrorVal = val.SumCallErrors.value + val.SumCallsFailed.value;
                let sumUnAnsVal = val.SumUnAnsCalls.value;
                // let successPercent = (sumAnsVal *100)/sumAttemptsVal;
                let failurePercent = ((sumErrorVal *100)/sumAttemptsVal).toFixed(2);
                let successPercent = ((sumAnsVal *100)/sumAttemptsVal).toFixed(2);
                // attemptsData.push({x:sumDate, y:sumAttemptsVal});
                // ansData.push({x:sumDate, y:sumAnsVal});
                // unAnsData.push({x:sumDate, y:sumUnAnsVal});
                // errorData.push({x:sumDate, y:sumErrorVal});
                failureData.push({x:sumDate, y:failurePercent, legend: 'Failed Calls %'});
                answeredData.push({x:sumDate, y:successPercent, legend: 'Answered Calls %'});
            })
            transformedData.push({domain: domain, failureData: failureData, answeredData: answeredData});
        }
    )
      console.log("transformed Inbound% Data",transformedData);

    } catch (error) {
      // this.setState({ error });
      console.error(error);
    } finally {
      // this.setState({ saving: false });
    }
    return transformedData;
  }

  fetchHighRiskCallsData = async (startTime, endTime, appDomain) => {
    const { client } = this.props;
    let result = [];
    let transformedData = [];
    console.log("send high risk call query to graphql")
    try {
      const callDetails = await client.query({
        query: GET_HIGH_RISK_CALLS,
        fetchPolicy: 'network-only',
        variables: {
          startTime: toString(startTime),
          endTime: toString(endTime),
          appDomain: appDomain
        },
      });
      console.log("logging high risk call from index.jsx");
      console.log(callDetails);
      // let pagecallDetails = [];
      result = callDetails.data.getHighRiskCalls ;

      result.forEach(
        function(val,index){
            let domain = val.key; 
            let highRiskData = [];
            val.CallSummary.buckets.forEach(function(val, index){
                //console.log(val);
                let sumDate = val.key;
                let sumHighRiskVal = val.SumHighRiskCounts.value;
                highRiskData.push({x:sumDate, y:sumHighRiskVal, legend: 'High Risk Calls'});
            })
            transformedData.push({domain: domain, highRiskData: highRiskData});
        }
    )
      console.log("transformed High Risk Data",transformedData);

    } catch (error) {
      // this.setState({ error });
      console.error(error);
    } finally {
      // this.setState({ saving: false });
    }
    return transformedData;
  }

  render() {
    const { props } = this;
    const { classes } = props;
    const {
      appDomain,
      callAttemptsData,
      outboundCallsData,
      inboundCallsData,
      onNetCallsData,
      searchDone,
      searchStart,
      shortTime,
      appDomainEntered,
      inboundPercentCallsData,
      updatedHighRiskData
    } = this.state;
    return (
      <Panel
        id="callSummaryReport"
        title={(
          <div className={classes.panelHeader}>
            Historical Call Trends
            <DateFilter onClickDateFilter={props.onClickDateFilter} />
          </div>
        )}
        classes={{ title: classes.title }}
        avatar={<Call className={classes.iconStyles} />}
      >
        <FormControl className={classes.formControl}>
          <FormField
            placeholder="Enter App Domain"
            id="appDomain"
            name="appDomain"
            classes={{ root: classes.root, formFieldWrapper: classes.formFieldWrapper }}
            className={classes.searchBox}
            value={appDomain}
            onChange={(event) => {
              this.onChangeInput(event);
              this.setState({ appDomainEntered: true });
            }}
          />
          <Button
            className={classes.searchBtn}
            disabled={!appDomainEntered}
            onClick={this.onSearchCalls}
          >
            Search
          </Button>
        </FormControl>

        <Grid item xs={12}>
        {shortTime && <div className={classes.noRecords}> Selected time range should be longer than 24 hours</div>}
        <div><br></br>
        {searchStart && <img src={ require('./loading.gif')}/>}      
        </div>
          {/* <div><br></br>
          <CallAttempts 
          callDetailsData={callAttemptsData} 
          searchDone={searchDone}
          />
          </div> */}
          {searchDone && <>
          <div><br></br>
          <OutboundSummary 
          callDetailsData={outboundCallsData} 
          searchDone={searchDone}
          />
          </div>

          <div><br></br>
          <InboundSummary 
          callDetailsData={inboundCallsData} 
          searchDone={searchDone}
          />
          </div>
          <div><br></br>
          <OnNetSummary 
          callDetailsData={onNetCallsData} 
          searchDone={searchDone}
          />
          </div>
          
          {/* <div><br></br>
          <InboundPercentSummary 
          callDetailsData={inboundPercentCallsData} 
          searchDone={searchDone}
          />
          </div> */}

          <div><br></br>
          <InternationalSummary 
          callDetailsData={outboundCallsData} 
          searchDone={searchDone}
          />
          </div>

          <div><br></br>
          <BlockedSummary 
          callDetailsData={outboundCallsData} 
          searchDone={searchDone}
          />
          </div>

          <div><br></br>
          <HighRiskSummary 
          callDetailsData={updatedHighRiskData} 
          searchDone={searchDone}
          />
          </div>
          </>}
        </Grid>
      </Panel>
    );
  }
}

// CallSummaryData.propTypes = {
//   client: PropTypes.object.isRequired,
// };

export default withStyles(styles)(withApollo(CallSummaryData));
